import SafeIconGray from './SafeIconGray'

export default SafeIconGray
